import { render, staticRenderFns } from "./Instruction.vue?vue&type=template&id=3e2070bc&scoped=true"
import script from "./Instruction.vue?vue&type=script&lang=js"
export * from "./Instruction.vue?vue&type=script&lang=js"
import style0 from "./Instruction.vue?vue&type=style&index=0&id=3e2070bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2070bc",
  null
  
)

export default component.exports